
// Helper function to generate code verifier and challenge
export const generateCodeChallenge = () => {
  const codeVerifier = Array.from(crypto.getRandomValues(new Uint8Array(32)))
    .map(b => String.fromCharCode(b))
    .join('')
    .replace(/[^a-zA-Z0-9]/g, '')
    .substring(0, 43);
  
  return codeVerifier;
};

const base64URLEncode = (str: ArrayBuffer) => {
  return btoa(String.fromCharCode(...new Uint8Array(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const generateCodeChallengeFromVerifier = async (verifier: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64URLEncode(digest);
};

export const buildEtsyOAuthUrl = async () => {
  const codeVerifier = generateCodeChallenge();
  const codeChallenge = await generateCodeChallengeFromVerifier(codeVerifier);
  
  // Store code verifier in localStorage for later use
  localStorage.setItem('etsy_code_verifier', codeVerifier);
  
  return `https://www.etsy.com/oauth/connect?response_type=code&redirect_uri=https://ordereaseonline.com/etsy-callback&scope=email_r%20shops_r%20transactions_r%20listings_r&client_id=vm3qepd0ddzibor4b9dzoj3k&state=superstring&code_challenge=${codeChallenge}&code_challenge_method=S256`;
};
